import { jsx as _jsx } from "react/jsx-runtime";
import FormattedMessage from 'I18n/components/FormattedMessage';
import H4 from 'UIComponents/elements/headings/H4';
import { AnimatedStepBody } from '../animation/StepBodyAnimations';
export const LoadingTitle = ({
  title
}) => {
  return /*#__PURE__*/_jsx(AnimatedStepBody, {
    children: /*#__PURE__*/_jsx(H4, {
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: title
      })
    })
  }, title);
};